<template>
  <button @click="exportCallFeeOverview" class="btn btn-sm btn-info mr-1 mb-1" :disabled="!data || !data.length">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from "exceljs";
import moment from "moment";

export default {
  name: "CallFeeOverviewExport",
  props: ['data', 'filterFormModel'],
  data() {
    return {
      exporting: false,
      sum: {},
      avg: {}
    }
  },
  methods: {
    exportCallFeeOverview: function() {
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      let columns = [ {header: '', key: 'label', width: 40}];
      if (this.filterFormModel.group === 'client') {
        columns.push(
          { header: this.$t('sales'), key: 'sales', width: 15 },
          { header: this.$t('account'), key: 'account', width: 15 },
          { header: this.$t('activeTime'), key: 'activeTime', width: 15 },
          { header: this.$t('createTime'), key: 'createTime', width: 15 },
        )
      }
      columns.push(
        {header: this.$t('totalCall'), key: 'totalCall', width: 15},
        {header: this.$t('missCall'), key: 'missCall', width: 15},
        {header: this.$t('successCount'), key: 'successCount', width: 10},
        {header: this.$t('callFee'), key: 'callFee', width: 15},
        {header: this.$t('callFeeOffNetwork'), key: 'callFeeOffNetwork', width: 15},
        {header: this.$t('offNetworkCount'), key: 'offNetworkCount', width: 10},
        {header: this.$t('chargeDuration'), key: 'chargeDuration', width: 10},
      );
      sheet.columns = columns;
      this.sum = {};
      this.data.forEach(item => {
        for (let key in item) {
          if (!['_id', 'label', 'clientSales', 'clientAccount', 'clientActiveTime', 'clientCreateTime'].includes(key)) {
            if (!this.sum[key]) {
              this.sum[key] = 0;
            }
            this.sum[key] += item[key];
          }
        }
      });
      this.avg = {};
      for (let key in this.sum) {
        this.avg[key] = Math.round(this.sum[key] / this.data.length);
      }
      sheet.addRow({
        label: this.$t('total'),
        totalCall: this.sum.total,
        missCall: this.sum.missCall,
        successCount: this.sum.success,
        callFee: this.sum.chargedFee,
        callFeeOffNetwork: this.sum.offNetworkFee,
        offNetworkCount: this.sum.offNetwork,
        chargeDuration: this.sum.chargeDuration,
      })
      sheet.addRow({
        label: this.$t('avg'),
        totalCall: this.avg.total,
        missCall: this.avg.missCall,
        successCount: this.avg.success,
        callFee: this.avg.chargedFee,
        callFeeOffNetwork: this.avg.offNetworkFee,
        offNetworkCount: this.avg.offNetwork,
        chargeDuration: this.avg.chargeDuration,
      })
      this.data.forEach(item => {
        let row = {
          label: this.label(item),
          sales: item.clientSales ? item.clientSales : '',
          account: item.clientAccount ? item.clientAccount : '',
          activeTime: item.clientActiveTime ? moment(item.clientActiveTime).format('MM/DD/YYYY') : '',
          createTime: item.clientCreateTime ? moment(item.clientCreateTime).format('MM/DD/YYYY') : '',
          totalCall: item.total,
          missCall: item.missCall,
          successCount: item.success,
          callFee: item.chargedFee,
          callFeeOffNetwork: item.offNetworkFee,
          offNetworkCount: item.offNetwork,
          chargeDuration: item.chargeDuration,
        }
        sheet.addRow(row)
      })
      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'call-fee-overview.xlsx');
      })
    },
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('ll');
      }
    },
  },
  i18n: {
    messages: {
      en: {
        avg: 'Average',
        callFee: 'Call fee',
        successCount: 'Number of call connected',
        chargeDuration: 'Charged duration',
        callFeeOffNetwork: 'Off network call fee',
        offNetworkCount: 'Number of off network call',
        account: 'AM',
        activeTime: 'Active time',
        totalCall: "Total calls",
        missCall: "Missed call",
      },
      vi: {
        avg: 'Trung bình',
        callFee: 'Cước gọi',
        successCount: 'Số cuộc gọi kết nối thành công',
        chargeDuration: 'Thời lượng tính phí',
        callFeeOffNetwork: 'Cước gọi ngoại mạng',
        offNetworkCount: 'Số cuộc gọi ngoại mạng',
        account: 'AM',
        activeTime: 'Kích hoạt lúc',
        totalCall: "Số lượng cuộc gọi",
        missCall: "Gọi nhỡ",
      }
    }
  }
}
</script>
